import React from 'react';

// Anillo de protección · visual firma · 8 segmentos = strikes 0–7
const polar = (cx, cy, r, deg) => {
  const a = (deg * Math.PI) / 180;
  return [cx + r * Math.cos(a), cy + r * Math.sin(a)];
};

export const ProtectionRing = ({ filled = 0, total = 8, size = 220, children }) => {
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 14;
  const arc = (i) => {
    const a0 = -90 + i * (360 / total) + 4;
    const a1 = -90 + (i + 1) * (360 / total) - 4;
    const [x0, y0] = polar(cx, cy, r, a0);
    const [x1, y1] = polar(cx, cy, r, a1);
    return `M ${x0.toFixed(2)} ${y0.toFixed(2)} A ${r} ${r} 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)}`;
  };
  return (
    <div className="mbm-ring" style={{ width: size, height: size }} data-testid="protection-ring">
      <svg width={size} height={size} aria-hidden="true">
        {Array.from({ length: total }).map((_, i) => (
          <path
            key={i}
            d={arc(i)}
            fill="none"
            stroke={i < filled ? '#1D1D1D' : '#E2E2E2'}
            strokeWidth={i < filled ? 9 : 6}
            strokeLinecap="round"
            className="ring-seg"
            style={{ transitionDelay: `${i * 60}ms` }}
          />
        ))}
      </svg>
      <div className="ring-center">{children}</div>
    </div>
  );
};
